// Keep the identity function around for default iteratees.
export default function identity(value) {
  return value;
}



//////////////////
// WEBPACK FOOTER
// /Users/gengis/Documents/WORK/_LOCAL_MAMP/genethon-2020/web/app/themes/genethon/node_modules/underscore/modules/identity.js
// module id = 37
// module chunks = 0